<script setup>
import ToggleTaskOnHoldAction from "@frontJs/components/actions/projectManagement/tasks/ToggleTaskOnHoldAction.vue";
import { PlayIcon, PauseIcon } from "@heroicons/vue/24/outline";
import ActionButton from "@js/components/ActionButton.vue";
import { useElementHover } from "@vueuse/core";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { task, callback } = defineProps({
  task: {
    type: Object,
    required: true,
  },
  callback: {
    type: Function,
    required: true,
  },
});

const { t } = useI18n();

const button = ref(null);
const buttonIsHovered = useElementHover(button);
</script>

<template>
  <div class="flex items-center justify-start gap-2 p-4">
    <ToggleTaskOnHoldAction :task="task" :callback="callback">
      <template #button="{ action }">
        <ActionButton
          ref="button"
          size="small"
          class="size-8"
          :title="task.onHold ? t('button.resume') : t('button.pause')"
          :type="task.onHold ? 'danger' : 'success'"
          :icon="
            buttonIsHovered
              ? task.onHold
                ? PlayIcon
                : PauseIcon
              : task.onHold
                ? PauseIcon
                : PlayIcon
          "
          :callback="() => action()"
        />
      </template>
    </ToggleTaskOnHoldAction>
  </div>
</template>
